import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "w-full flex flex-row justify-center items-center mt-2" }
const _hoisted_3 = ["onUpdate:modelValue"]
const _hoisted_4 = { class: "flex flex-col w-12 h-12 justify-center items-center" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-6 w-6",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z",
      "clip-rule": "evenodd"
    })
  ])
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "flex flex-row w-full justify-start items-start mt-2 space-x-6" }
const _hoisted_9 = { class: "flex flex-row justify-center items-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "Sourcing admin", -1)
const _hoisted_11 = {
  key: 0,
  class: "flex flex-row justify-center items-center"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "Workforce admin", -1)
const _hoisted_13 = { class: "flex flex-row justify-center items-center" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "Sourcing recruiter", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "border-t flex flex-col w-full mt-4 border-gray-50" }, null, -1)
const _hoisted_16 = { class: "flex flex-row mt-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-5 w-5",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
      "clip-rule": "evenodd"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "Add another member")
], -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "flex flex-row justify-end" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invitesList, (invite, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: i,
        class: _normalizeClass(["flex flex-col items-center justify-between w-full", { 'mt-4': i > 0 }])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": ($event: any) => ((_ctx.invitesList[i].email) = $event),
            class: "bg-gray-200 p-4 rounded focus:outline-none w-full"
          }, null, 8, _hoisted_3), [
            [_vModelText, _ctx.invitesList[i].email]
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              onClick: ($event: any) => (_ctx.removeLine(i)),
              class: "text-gray-400 p-3 ml-4 rounded-full hover:bg-red-100 hover:text-red-400"
            }, _hoisted_7, 8, _hoisted_5)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_Checkbox, {
              onClick: ($event: any) => (
              _ctx.changeRole(
                i,
                !_ctx.invitesList[i].sourcing,
                _ctx.invitesList[i].workforce,
                _ctx.invitesList[i].recruiter
              )
            ),
              selected: _ctx.invitesList[i].sourcing
            }, null, 8, ["onClick", "selected"]),
            _hoisted_10
          ]),
          (_ctx.hasWorkfoceProduct)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_Checkbox, {
                  onClick: ($event: any) => (
              _ctx.changeRole(
                i,
                _ctx.invitesList[i].sourcing,
                !_ctx.invitesList[i].workforce,
                _ctx.invitesList[i].recruiter
              )
            ),
                  selected: _ctx.invitesList[i].workforce
                }, null, 8, ["onClick", "selected"]),
                _hoisted_12
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_Checkbox, {
              onClick: ($event: any) => (
              _ctx.changeRole(
                i,
                _ctx.invitesList[i].sourcing,
                _ctx.invitesList[i].workforce,
                !_ctx.invitesList[i].recruiter
              )
            ),
              selected: _ctx.invitesList[i].recruiter
            }, null, 8, ["onClick", "selected"]),
            _hoisted_14
          ])
        ]),
        _hoisted_15
      ], 2))
    }), 128)),
    _createElementVNode("div", _hoisted_16, [
      (!_ctx.hascompanyPlan || _ctx.invitesList.length < _ctx.remaining_collaborators)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addNewLine && _ctx.addNewLine(...args))),
            class: "btn-text px-2 py-2 hover:bg-purple-50"
          }, _hoisted_18))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.sendInvites && _ctx.sendInvites(...args))),
        disabled: _ctx.loading || !_ctx.isValid,
        class: _normalizeClass({
          'btn-filled-lg': !_ctx.loading,
          'btn-filled-lg-loading': _ctx.loading,
        })
      }, [
        (!_ctx.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_21, "Send invitations"))
          : (_openBlock(), _createElementBlock("span", _hoisted_22, "Loading..."))
      ], 10, _hoisted_20)
    ])
  ]))
}